import React,{useEffect,useState} from "react";
import {approveReservation,
    rejectReservation,
    confirmReservation,
    cancelReservation,
    arrivedReservation,
    markReservationAsAttended
} from "../../../../../crud/clients_api/client_reservations";
import {Button,Modal} from "react-bootstrap";
import {toast} from "react-toastify";
import MiniLoadingSpinner from "../../../../../components/Spinners/MiniLoadingSpinner";

interface ReservationModalProps {
    reservation:any
    onHide:() => void
    show:boolean
    onCancelConfirmed?: () => void;
    onConfirmConfirmed?: () => void;
    onRejectConfirmed?: () => void;
    onMarkAsAttended?: () => void;
    onMarkAsArrived?: () => void;
}

export const RenderCancelModal:React.FC<ReservationModalProps> = ({reservation,onHide,show,onCancelConfirmed}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);

    const handleCancel = () => {
        console.log("Canceling reservation");
        setLoading(true);
        cancelReservation(reservation.reservation_id).then((response) => {
            console.log(response);
            toast.success("Reserva cancelada");
            setLoading(false);
            reservation.status = "Cancelada";
            if (onCancelConfirmed) onCancelConfirmed(); // actualiza solo después de confirmar
            onHide();
        }).catch((error) => {
            console.log(error);
            toast.error("Error al cancelar la reserva");
            setError(error?.data?.message)
            setLoading(false);
        });
    }

    return (<Modal onHide={onHide} show={show}>
        <Modal.Header >
            <Modal.Title>Cancelar Reserva</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <div className="reservation-render-functions-modals-body">
            {loading && <MiniLoadingSpinner />}
            {(!loading && error) && <p>{error}</p>}
            {(!loading && !error) && <>
                <p>¿Está seguro que desea cancelar la reserva?</p>
                <Button onClick={handleCancel} variant="none" className="form-button-create">Cancelar reserva</Button>
            </>}
        </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
        </Modal.Footer>
    </Modal>)
}

export const ConfirmReservationModal:React.FC<ReservationModalProps> = ({reservation, onHide,show,onConfirmConfirmed}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);
    
        const handleConfirm = () => {
            console.log("Confirming reservation");
            setLoading(true);
            confirmReservation(reservation.reservation_id).then((response) => {
                console.log(response);
                toast.success("Reserva confirmada");
                setLoading(false);
                reservation.status = "Confirmada";
                if (onConfirmConfirmed) onConfirmConfirmed();
                onHide();
            }).catch((error) => {
                console.log(error);
                toast.error("Error al confirmar la reserva");
                setError(error?.data?.message)
                setLoading(false);
            });
        }
    
        return (<Modal onHide={onHide} show={show}>
            <Modal.Header >
                <Modal.Title>Confirmar Reserva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div className="reservation-render-functions-modals-body">
                {loading && <MiniLoadingSpinner />}
                {(!loading && error) && <p>{error}</p>}
                {(!loading && !error) && <>
                    <p>¿Está seguro que desea confirmar la reserva?</p>
                    <Button variant='none' className='form-button-create' onClick={handleConfirm}>Confirmar Reserva</Button>
                </>}
            </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>)
    }

export const ApproveReservationModal:React.FC<ReservationModalProps> = ({reservation,onHide,show}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);
        
    const handleApprove = () => {
        console.log("Approving reservation");
        setLoading(true);
        approveReservation(reservation.reservation_id).then((response) => {
            console.log(response);
            toast.success("Reserva aprobada");
            setLoading(false);

            // Actualizar el estado de la reserva en tiempo real
            reservation.status = "Por Confirmar";
            reservation.approved = true;

            onHide();
        }).catch((error) => {
            console.log(error);
            toast.error("Error al aprobar la reserva");
            setError(error?.data?.message);
            setLoading(false);
        });
    };

    return (
        <Modal onHide={onHide} show={show}>
            <Modal.Header>
                <Modal.Title>Aprobar reserva</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="reservation-render-functions-modals-body">
                    {loading && <MiniLoadingSpinner />}
                    {(!loading && error) && <p>{error}</p>}
                    {(!loading && !error) && (
                        <>
                            <p>¿Está seguro que desea aprobar la reserva?</p>
                            <Button variant="none" className="form-button-create" onClick={handleApprove}>Aprobar reserva</Button>
                        </>
                    )}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
};

export const RejectReservationModal:React.FC<ReservationModalProps> = ({reservation, onHide, show, onRejectConfirmed}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);
                
            const handleReject = () => {
                console.log("Rejecting reservation");
                setLoading(true);
                rejectReservation(reservation.reservation_id).then((response) => {
                    console.log(response);
                    toast.success("Reserva rechazada");
                    setLoading(false);
                    reservation.status = "Rechazada";
                    if (onRejectConfirmed) onRejectConfirmed();
                    onHide();
                }).catch((error) => {
                    console.log(error);
                    toast.error("Error al rechazar la reserva");
                    setError(error?.data?.message)
                    setLoading(false);
                });
                    }
                
            return (<Modal onHide={onHide} show={show}>
                <Modal.Header >
                    <Modal.Title>Rechazar Reserva</Modal.Title>
                </Modal.Header>
                        <Modal.Body>
                        <div className="reservation-render-functions-modals-body">
                        {loading && <MiniLoadingSpinner />}
                        {(!loading && error) && <p>{error}</p>}
                        {(!loading && !error) && <>
                            <p>¿Está seguro que desea rechazar la reserva?</p>
                            <Button variant="none" className="form-button-create" onClick={handleReject}>Rechazar reserva</Button>
                        </>}
                        </div>
                        </Modal.Body>
                        <Modal.Footer>
                        <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
                        </Modal.Footer>
                    </Modal>)
                }

export const MarkArrrivedModal:React.FC<ReservationModalProps> = ({reservation,onHide,show,onMarkAsArrived}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);
    
    const handleMarkAsArrived = () => {
        console.log("Marking reservation as arrived");
        setLoading(true);
        arrivedReservation(reservation.reservation_id).then((response) => {
            console.log(response);
            toast.success("El Cliente ha llegado, está siendo atendido");
            setLoading(false);
            // Actualiza el estado local si es necesario
            if (onMarkAsArrived) onMarkAsArrived();
            onHide();
        }).catch((error) => {
            console.log(error);
            toast.error("Error al marcar la reserva como recibida");
            setError(error?.data?.message)
            setLoading(false);
        });
    }
    
    return (
        <Modal onHide={onHide} show={show}>
            <Modal.Header>
                <Modal.Title>Marcar como recibido los clientes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="reservation-render-functions-modals-body">
                    {loading && <MiniLoadingSpinner  />}
                    {(!loading && error) && <p>{error}</p>}
                    {(!loading && !error) &&
                        <>
                            <p>¿Está seguro que desea marcar la reserva esta en proceso?</p>
                            <Button variant="none" className="form-button-create" onClick={handleMarkAsArrived}>Marcar como Recibido</Button>
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export const MarkAttendedModal:React.FC<ReservationModalProps> = ({reservation,onHide,show,onMarkAsAttended}) => {
    const [loading,setLoading] = useState(false);
    const [error,setError] = useState(null);
    
    const handleMarkAsAttended = () => {
        console.log("Marking reservation as attended");
        setLoading(true);
        markReservationAsAttended(reservation.reservation_id).then((response) => {
            console.log(response);
            toast.success("El Cliente ya fue del local");
            setLoading(false);
            // Actualiza el estado local en tiempo real
            if (onMarkAsAttended) onMarkAsAttended();
            onHide();
        }).catch((error) => {
            console.log(error);
            toast.error("Error al marcar la reserva atendida");
            setError(error?.data?.message)
            setLoading(false);
        });
    }
    
    return (
        <Modal onHide={onHide} show={show}>
            <Modal.Header>
                <Modal.Title>Marcar como clientes atendidos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="reservation-render-functions-modals-body">
                    {loading && <MiniLoadingSpinner  />}
                    {(!loading && error) && <p>{error}</p>}
                    {(!loading && !error) &&
                        <>
                            <p>¿Está seguro que desea marcar la reserva fue finalizada?</p>
                            <Button variant="none" className="form-button-create" onClick={handleMarkAsAttended}>Marcar como finalizada</Button>
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant='none' className="form-button-cancel" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    )
}
